import { BaseModal, ModalOptions, ModalColor, ModalResultType } from "../../../../../../core/modal/index";
import { Template } from "../../../../../../core/template/index";
import ConfirmModal from "../../../../../../core/modals/confirm/index";
import { SelectOptionData } from "../../../../../../core/view/data-bind/types/selectbox-base";
import { ClientAction } from "../../../../../synchronizer/index";
import { FortumApp } from "../../../../../fortumApp";
import DeconCleansingTypeUsage, { CleansingInstanceLike, CleansingTypeUsageLike, CleansingInstance } from "../../../../../db/models/decontamination/cleansingTypeusage";
import { CleansingType, MeasuringTypeLike, MeasuringType } from "../../../../../db/models/decontamination/index";
import ListView from "../../../../../../core/component/listView/index";
import { MeasurementLike, Measurement } from "../../../../../db/models/decontamination/measurement";
import { ViewDataBindEvents, DataPropertyChangedEventArgs } from "../../../../../../core/view/data-bind/index";
import { OrderItem } from "../../../../../db/models/decontamination/orderItem";


export default class OrderItemEditMeasurementModal extends BaseModal
{
    public template = Template.lazy('/app/views/decontamination/orderItem/modals/edit-measurement/index.html');
    public data: OrderItemEditMeasurementModalData;
    public app: FortumApp;
    private saveButton: HTMLButtonElement;
    private cancelButton: HTMLButtonElement;
    private removeButton: HTMLButtonElement;
    private cancelRemoveButton: HTMLButtonElement;
    private availableCleansingInstances: CleansingInstanceLike[];
    private availableMeasuringTypes: MeasuringTypeLike[];
    private afterValueErrorMessage: HTMLElement;
    private invalidValueErrorMessage: HTMLElement;
    private missingAfterValueMessage: HTMLElement;
    private valueBeforeField: HTMLInputElement;
    private valueAfterField: HTMLInputElement;

    private operatorNotesFieldWrapper: HTMLElement;

    private footer: HTMLElement;
    private confirmation: HTMLElement;

    constructor(data?: OrderItemEditMeasurementModalData)
    {
        super(data);
    }

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('decontamination.OrderItem', 'Edit measurement')
        }
    }

    public beforeRender(): PromiseLike<void>
    {
        this.data.title = this.title;
        this.on(ViewDataBindEvents.DATA_CHANGED, this.onDataChanged);
        return super.beforeRender().then(() =>
        {
            return Promise.all([
                this.app.db.DeconMeasuringType.toArray(),
                this.app.db.DeconOrderItem.where('id').equals(this.data.item_id).first(),
            ]);
        }).then((results) =>
        {
            this.data.item = results[1];
            let measurementTypes: MeasuringTypeLike[] = results[0];

            this.availableMeasuringTypes = measurementTypes.filter(o => !o.is_legacy);
            console.log('isnew', this.data.isNew, this.data);
            // Limit choices to existing type & types of same group
            if (!this.data.isNew) {
                this.availableMeasuringTypes = this.availableMeasuringTypes.filter(o => o.id == this.data.type.id || (o.group && o.group == this.data.type.group));
            }
            this.data.availableMeasuringTypes = [
                {content: '-----', value: ''},
            ];
            // combine options. Exclude ----- option if not entirely new measurement
            this.data.availableMeasuringTypes = (this.data.isNew ? this.data.availableMeasuringTypes : []).concat(this.availableMeasuringTypes.map(o => <SelectOptionData>{
                content: `${o.group ? `[${o.group}]` : ''} ${o.name} (${o.unit})${o.optionality == MeasuringType.OPTIONALITY_REQUIRED ? ' *' : ''}`,
                value: o.id,
            }));
            
            if (this.data.type_id != null)
            {
                this.data.selectedMeasuringType = this.data.availableMeasuringTypes.find(o => o.value == this.data.type_id);
            }
            else
            {
                this.data.selectedMeasuringType = this.data.availableMeasuringTypes[this.data.availableMeasuringTypes.length > 1 ? 1 : 0];
            }
            console.log(this.data.selectedMeasuringType, this.data.type_id)
        });
    }
    
    private onDataChanged = (sender, args: DataPropertyChangedEventArgs) =>
    {
        if (args.propertyName == 'selectedMeasuringType' || args.propertyName == 'selectedCleansingInstance')
        {
            this.updateSaveButtonDisabledState();
        }
        else if (args.propertyName == 'value_before' || args.propertyName == 'value_after')
        {
            this.updateSaveButtonDisabledState();
        }
        else if(args.propertyName == 'is_incomplete')
        {
            this.updateOperatorNotesFieldVisibility();
        }
    };

    private updateOperatorNotesFieldVisibility()
    {
        this.operatorNotesFieldWrapper.style.display = this.data.is_incomplete ? 'block' : 'none';
    }

    private updateSaveButtonDisabledState(isFirstRun = false)
    {
        if (this.data.isNew)
        {
            this.removeButton.style.display = 'none';
        }
        let isValueAfterInRange = true;

        let valueBefore: string | number = `${this.data.value_before != null ? this.data.value_before : ''}`;
        let valueAfter: string | number = `${this.data.value_after != null ? this.data.value_after : ''}`;

        valueBefore = valueBefore != '' ? parseFloat(valueBefore.replace(',', '.')) : null;
        valueAfter = valueAfter != '' ? parseFloat(valueAfter.replace(',', '.')) : null;

        let isValueBeforeValid = !isNaN(valueBefore) && !this.valueBeforeField.validity.badInput;
        let isValueAfterValid = !isNaN(valueAfter) && !this.valueAfterField.validity.badInput;
        let isValueBeforeEntered = valueBefore != null;
        let isValueAfterEntered = valueAfter != null;

        if (isValueBeforeValid && isValueAfterValid && isValueBeforeEntered)
        {
            isValueAfterInRange = Measurement.isValid(valueBefore, valueAfter, true);
        }

        this.saveButton.disabled = !isValueAfterInRange || !isValueBeforeValid || !isValueAfterValid || this.data.selectedMeasuringType.value == '' || (!isValueBeforeEntered && !isValueAfterEntered);
        
        if (isFirstRun && this.data.id == null)
        {
            isValueBeforeValid = true;
            isValueAfterValid = true;
            isValueAfterInRange = true;
            isValueAfterEntered = true;
        }

        this.valueBeforeField.classList[isValueBeforeValid ? 'remove' : 'add']('invalid');
        this.valueAfterField.classList[isValueAfterValid && isValueAfterInRange ? 'remove' : 'add']('invalid');

        this.afterValueErrorMessage.style.display = isValueAfterInRange ? 'none' : 'flex'; 
        this.invalidValueErrorMessage.style.display = (isValueBeforeValid && isValueAfterValid) ? 'none' : 'flex';
        // Display if "before" is entered and after is not
        this.missingAfterValueMessage.style.display = (isValueBeforeEntered && !isValueAfterEntered)  ? 'flex' : 'none';
    }

    public afterRender()
    {
        return super.afterRender().then(() =>
        {
            this.updateSaveButtonDisabledState(true);
            this.updateOperatorNotesFieldVisibility();
        });
    }

    private onCancelButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(sender, false); 
        this.close(ModalResultType.CANCEL);
    }

    private get title()
    {
        if (this.data.id == null)
        {
            return this.pgettext('decontamination.OrderItem', 'Add measurement'); 
        }
        
        return this.pgettext('decontamination.OrderItem', 'Edit measurement');
    }

    private get toastText()
    {
        return this.app.pgettext('decontamination.OrderItem', 'Successfully updated measurement!')
    }

    private onSaveButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(this.saveButton, false); 
        this.helpers.setButtonEnabled(this.removeButton, false); 
        this.helpers.setButtonEnabled(this.cancelButton, false); 

        this.app.db.DeconMeasurement.put({
            item_id: this.data.item_id,
            ...(this.data.id ? {id: this.data.id} : {}),
            type_id: parseInt(this.data.selectedMeasuringType.value as string),
            is_incomplete: this.data.is_incomplete,
            operator_notes: this.data.operator_notes,
            value_before: parseFloat(<any>this.data.value_before),
            value_after: parseFloat(<any>this.data.value_after),
            is_offline: 1,
        }).then(() => {
            return OrderItem.trySetStarted(this.app.db, this.data.item.order_id, this.data.item_id);
        }).then(() => {
            return this.app.synchronizer.createMessageAndPull({
                action: ClientAction.DECONTAMINATION.UPDATE_ORDER_ITEM_MEASUREMENT,
                data: {
                    order_item_id: this.data.item_id,
                    measurement_id: this.data.id,
                    measuring_type_id: this.data.selectedMeasuringType.value,
                    is_incomplete: this.data.is_incomplete,
                    operator_notes: this.data.operator_notes,
                    //cleansing_instance_id: this.data.selectedCleansingInstance.value,
                    value_before: parseFloat(<any>this.data.value_before),
                    value_after: parseFloat(<any>this.data.value_after),
                }
            }).then(() =>
            {
                this.close(ModalResultType.OK).then(() =>
                {
                    this.app.toasts.show(this.toastText);
                })
            });
        })
    }

    private onRemoveButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {   
        this.helpers.setButtonEnabled(this.removeButton, false);
        this.helpers.setButtonEnabled(this.saveButton, false);
        this.helpers.setButtonEnabled(this.cancelButton, false);
        this.footer.style.display = 'none';
        this.confirmation.style.display = 'block';
    }

    private onConfirmRemoveButtonClick(e: MouseEvent, sender: HTMLButtonElement) {
        this.helpers.setButtonEnabled(sender, false);
        this.helpers.setButtonEnabled(this.cancelRemoveButton, false);
        return this.app.db.DeconMeasurement.where('id').equals(this.data.id).delete().then(() => {
            return this.app.synchronizer.push({
                action: ClientAction.DECONTAMINATION.REMOVE_ORDER_ITEM_MEASUREMENT,
                data: {
                    order_item_id: this.data.item.id,
                    measurement_id: this.data.id,
                }
            }, true, false).then(() => {
                this.app.refreshCurrentView({tab: 'measuring'}).then(() => {
                    this.app.toasts.show(this.app.pgettext(
                        'decontamination.OrderItem',
                        'Successfully removed a measurement!'
                    ));
                });
                this.close();
            });
        });
    }

    private onCancelRemoveButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(this.removeButton, true);
        this.helpers.setButtonEnabled(this.saveButton, true);
        this.helpers.setButtonEnabled(this.cancelButton, true);
        this.footer.style.display = 'flex';
        this.confirmation.style.display = 'none';
    }
}

export interface OrderItemEditMeasurementModalData extends MeasurementLike, ModalOptions
{
    isNew?: boolean;

    //availableCleansingInstances?: SelectOptionData[];
    //selectedCleansingInstance?: SelectOptionData;

    availableMeasuringTypes?: SelectOptionData[];
    selectedMeasuringType?: SelectOptionData;
    selecedUnit?: string;
}